
export default {
  name: 'ShariaCompliance',
}
